const rtmpUrlIsValidRE = /^rtmps?:\/\/[^\s\/]+\/[^\s]+$/;
const rtmpUserInfoRE = /^rtmps?:\/\/([^:]+):([^@]+)@[^\s\/]+\/[^\s]+$/;

export function IsRtmpURLValid(url) {
  return rtmpUrlIsValidRE.test(url);
}

// Remove user info (username/password) from an RTMP URL.
export function SanitizeRTMPURL(url) {
  const matches = url.match(rtmpUserInfoRE);
  if (matches && matches.length == 3) {
    const usernameEncoded = matches[1];
    const passwordEncoded = matches[2];
    return url.replace(`://${usernameEncoded}:${passwordEncoded}@`, '://');
  }
  return url;
}

// Modifies the object that is returned from the API into a format used by the client-side
// dashboard code. Specifically, it parses authentication information from the RTMP URL and
// places it in separate fields.
export function TransformRTMPPushChannelAPIToClient(rtmpPushChannel) {
  const streamUrl = rtmpPushChannel.stream_url;
  const matches = streamUrl.match(rtmpUserInfoRE);
  if (matches && matches.length == 3) {
    const usernameEncoded = matches[1];
    const passwordEncoded = matches[2];
    rtmpPushChannel.stream_url = streamUrl.replace(
      `://${usernameEncoded}:${passwordEncoded}@`,
      '://'
    );
    rtmpPushChannel.username = decodeURIComponent(usernameEncoded);
    rtmpPushChannel.password = decodeURIComponent(passwordEncoded);
  }
  return rtmpPushChannel;
}

// Modifies the object that is used by the client-side dashboard code into a format to be sent to
// the API. Specifically, it puts any authentication information kept in separate fields into the
// RTMP URL.
export function TransformRTMPPushChannelClientToAPI(rtmpPushChannel) {
  if (rtmpPushChannel.username && rtmpPushChannel.password) {
    const usernameEncoded = encodeURIComponent(rtmpPushChannel.username);
    const passwordEncoded = encodeURIComponent(rtmpPushChannel.password);
    rtmpPushChannel.stream_url = rtmpPushChannel.stream_url.replace(
      '://',
      `://${usernameEncoded}:${passwordEncoded}@`
    );
    delete rtmpPushChannel.username;
    delete rtmpPushChannel.password;
  }
  return rtmpPushChannel;
}



// WEBPACK FOOTER //
// ./app/utils/rtmp.js